import { Trans } from "react-i18next";

export const ScheduledEmptyState = () => {
  return (
    <div className="flex flex-1 items-center justify-center text-[14px] text-kds-fg-soft">
      <Trans>No pending posts</Trans>
    </div>
  );
};
